// src/components/UnpaidSuccessPage.js
import React from "react";
import "../styles/SuccessPage.css";

const UnpaidSuccessPage = () => {
    return (
        <div className="success-container">
            <div className="success-card">
                <div className="success-icon">🎉</div>
                <h2 className="success-title">Reservation Confirmed!</h2>
                <p className="success-message">
                    Thank you! Your reservation at <strong>Sol Cafe & Lounge</strong> has been confirmed.
                </p>
                <p className="success-note">We look forward to welcoming you!</p>
                <a href="/" className="success-button">
                    Return Home
                </a>
            </div>
        </div>
    );
};

export default UnpaidSuccessPage;
